import React from 'react';

export function renderCaseCustomer({ rowData }) {
  return (
    <div>
      <strong>{rowData.customerName}</strong>
      <br /> {rowData.name}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases/common.js